// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorItem_wrapper__DGGMz","wrapperActive":"ColorItem_wrapperActive__Q0Sd3"};